// Shared ETA calculation utility using OSRM routing
// Used by both the customer TrackingPage and the shop owner MapPage

export async function fetchEta(riderLat, riderLng, destLat, destLng) {
  try {
    const url =
      `https://router.project-osrm.org/route/v1/driving/` +
      `${riderLng},${riderLat};${destLng},${destLat}` +
      `?overview=false`;
    const res  = await fetch(url);
    const data = await res.json();
    if (data.code !== "Ok" || !data.routes?.length) return null;
    return { seconds: data.routes[0].duration, meters: data.routes[0].distance };
  } catch {
    return null;
  }
}

export function formatEta(seconds) {
  if (seconds == null) return null;
  if (seconds < 60) return "Less than a minute";
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min${mins !== 1 ? "s" : ""}`;
  const hrs = Math.floor(mins / 60);
  const rem = mins % 60;
  if (rem === 0) return `${hrs} hr${hrs !== 1 ? "s" : ""}`;
  return `${hrs} hr ${rem} min`;
}

export function formatDistance(meters) {
  if (meters == null) return null;
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
}